<div class="background sb-router-outlet__no-header pb-5">
  <div class="container text-center pt-3">
    <img src="https://springbot-assets.s3.us-east-1.amazonaws.com/images/logo-springbot-send.svg" class="sb-logo pt-5">
    <h1 class="my-5" *ngIf="verified">
      Your email is verified!
    </h1>

    <h1 class="my-5" *ngIf="userRegistration">
      Welcome to Springbot!
    </h1>

    <h1 class="my-5" *ngIf="passwordReset && !userRegistration">
      Password Reset
    </h1>

    <button *ngIf="!passwordReset && verified" class="btn btn-success mt-2" (click)="goToDash()">Go to dashboard</button>

    <div class="text-center register-form-container card mt-5 p-4 border-0" style="max-width:600px;margin:auto" *ngIf="!passwordReset && !verified && !loading">
      <div class="mt-2 mb-3">
        Oops! Something went wrong.
      </div>

      <div class="alert alert-danger" *ngIf="!!error">{{ error }}</div>
      <a *ngIf="passwordReset" routerLink="/password_reset">try again</a>
    </div>

    <p class="subheader w-75 m-auto mt-3 medium-gray-color pb-3" *ngIf="passwordReset">
      Enter a new password below<span *ngIf="userRegistration"> to get started</span>.
    </p>

    <div class="text-left password-form-container mt-5" *ngIf="passwordReset">
      <div class="alert alert-danger" *ngIf="!!error">{{ error }}</div>
      <form [formGroup]="passwordForm" (ngSubmit)="onSubmit()">

        <div class="field">
          <label class="form-label">New Password</label><br>

          <div class="input-group">
            <input class="form-control" name="password" (keyup)="error = ''" [ngClass]="{ 'is-invalid' : password.errors && (password.dirty || password.touched) }"
              formControlName="password" [attr.type]="showPassword ? 'text' : 'password'" required placeholder="At least 8 characters">

            <div class="input-group-prepend">
              <fa-icon [icon]="['fas', 'eye']" *ngIf="showPassword" (click)="showPassword = !showPassword"
                class="cursor-pointer position-absolute password-icon mt-2"></fa-icon>
              <fa-icon [icon]="['fas', 'eye-slash']" *ngIf="!showPassword" (click)="showPassword = !showPassword"
                class="cursor-pointer position-absolute password-icon mt-2"></fa-icon>
            </div>
          </div>

          <div *ngIf="password.invalid && (password.dirty || password.touched)" class="invalid-feedback">
            <span *ngIf="password.errors.required">
              Required
            </span>
            <span *ngIf="password.errors.minlength">
              Must be at least 8 characters
            </span>
          </div>
        </div>

        <button class="btn btn-success w-100 mt-2" [disabled]="loading">
          <span *ngIf="userRegistration">Get Started</span>
          <span *ngIf="!userRegistration">Update password</span>
        </button>
      </form>
    </div>

    <div *ngIf="loading" class="text-center p-5">
      <fa-icon [icon]="['fas', 'cog']" size="3x" [spin]="true" class="primary-blue-color"></fa-icon>
    </div>

  </div>
</div>
